const state = {
    cloneTierReq: null,
    cloneTierRes: null
};

const getters = {
    GET_CLONE_TIER_REQUEST: (state) => {
        return state.cloneTierReq;
    },
    GET_CLONE_TIER_RESPONSE: (state) => {
        return state.cloneTierRes;
    }
};

const actions = {
    CLEAR_SETUP_PRICING_STORE: ({ commit }) => {
        commit("clearPricingSetupStore");
    },
    SET_CLONE_TIER_REQUEST: ({ commit }, req) => {
        commit("saveCloneTierReq", req);
    },

    SET_CLONE_TIER_RESPONSE: ({ commit }, res) => {
        commit("saveCloneTierRes", res);
    }
};

const mutations = {
    clearPricingSetupStore: state => {
        state.cloneTierReq = null;
        state.cloneTierRes = null;
    },

    saveCloneTierReq: (state, req) => {
        state.cloneTierReq = req;
    },
    saveCloneTierRes: (state, res) => {
        state.cloneTierRes = res;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};